<template>
    <div id="missionDetails">
        <div id="headers">
            <img src="../assets/images/img_31.png" alt="" @click="returnPage">
            <div class="headerText">任务详情</div>
        </div>
        <!-- 头部 -->
        <div class="headerTop">
            <div class="timePanel">
                <div class="lefts">
                    <span class="tit">剩余时间</span>
                    <span class="num">{{surplusTimes}}</span>
                </div>
                <div class="rights">+{{detailData.price}}<span>元</span></div>
            </div>
        </div>
        <!-- 第一步 -->
        <div class="one">
            <!-- iskeywords：1表示无关键词，2表示有关键词 -->
            <div>
                <div v-if="detailData.iskeywords == 2" class="sign">第一步 搜索关键词</div>
                <div v-else class="sign">第一步 {{tips}}App</div>
            </div>
            <img :src="detailData.icon?detailData.icon:'../assets/images/img_77.png'" alt="" class="icons">
            <div v-if="detailData.iskeywords == 2" class="keyWord">关键词: {{detailData.keyword?detailData.keyword:'暂无'}}</div>

            <div v-if="detailData.iskeywords == 2" class="ranking">排名约<span>{{detailData.ranking}}</span>位 找到并{{tips}}</div>

            <div>
                <div v-if="detailData.iskeywords == 2" class="oneBtn" :data-clipboard-text="detailData.keyword" @click="toAppstore">前往App Store搜索并{{tips}}</div>
                <div v-else class="oneBtn" :data-clipboard-text="detailData.keyword" @click="toAppstore">前往App Store{{tips}}</div>
            </div>
        </div>

        <!-- 第二步 -->
        <div class="two">
            <div class="uploadPictures">
                <div class="title">
                    <div class="sign">第二步:点击获取并五星好评按示例图要求截图</div>
                </div>
                <div class="pictureFathers">
                    <div class="picture">
                        <div class="example">
                            <img class="example_one" :src="url" v-preview="url" alt="">
                            <img class="example_two" src="../assets/images/img_87.png" v-preview="url" alt="">
                        </div>
                        <div class="choiceImg">
                            <img :src="uploadPic.imgUrl" alt="">
                            <img src="../assets/images/img_14.png" alt="" v-if="uploadPic.show">
                            <input type="file"  accept="image/jpeg,image/png,image/jpg,image/gif" @change='getimg($event)'>
                        </div>
                    </div>
                </div>
                <div class="editText">
                    <span class="appid" v-if="detailData.api_type == 2"><b>AppleID</b></span>
                    <span class="appid" v-else><b>Apple ID</b></span>
                    <input type="text" maxlength="11" v-if="detailData.api_type == 2"  v-model="appleid" placeholder="截图中的AppleID账户" class="regNum">
                    <input type="text" maxlength="25" v-else  v-model="appleid" placeholder="截图中的Apple ID账户" class="regNum">
                </div>
                <div class="btn" @click="reward">提交审核</div>
            </div>
        </div>

        <popup :pops='pops' @fatherMethod='fatherMethod' @closed='closed' v-show="rewards"></popup>
        <popChoose @giveUp="giveUp" @notGiveUp="notGiveUp" v-show="choosePop"></popChoose>
    </div>
</template>

<script>
    // 引入弹窗
    import popup from '../components/Popup.vue'
    import popChoose from '../components/PopChoose.vue'

    import Clipboard from 'clipboard'

    // 引入助手接口
    import clientApi from '../assets/js/clientApi';

    // 引入vant
    import { Dialog } from 'vant';

    export default {
        components:{
            popup,
            popChoose,
        },
        data() {
            return {
                headersText:'',
                pops:{
                    icons:require('../assets/images/img_77.png'), //可选
                    iconWidth:60, // 可选（若有图片必填）
                    iconHeight:60, // 可选（若有图片必填）
                    tits1:'提交成功', // 可选
                    // tits2:'快去分享给小伙伴吧', // 可选
                    // conts:'我们会尽快审核为你发放奖励', // 可选
                    // contsRed:'+1.5元',
                    btns:'继续做任务',
                    btnMarginTop:20,
                    closeImg:require('../assets/images/img_15.png')
                },
                rewards:false,
                choosePop:false,
                receiveReward:false, // 是否可领取奖励
                url:'http://static.nineton.cn/a6cbe52ab984da90c1fee812e9601a68ccef68ed.png',
                detailData:{}, // 详情数据
                surplusTimes:'', // 剩余时间
                timer:null, // 计时器
                tips:"预约",//预约任务或者截图任务
                uploadPic:{'imgUrl':'','show':true}, //上传图片
                files:[], // 图片
                appleid:'',//用户的Apple ID

                activeAppTimer: null, // 开始打开app到可以领奖时的计时器
            }
        },
        mounted() {
            this.changeInit();
            this.addVisibles();
            // this.init();
        },
        destroyed() {
            this.removeVisible();
        },
        methods: {
            // 封装 visibilitychange事件
            hiddens(){
                if(!document.hidden){ 
                    clearInterval(this.timer);
                    this.surplusTimes = '';
                    this.changeInit();
                }
            },
            // 封装一个base64转file的函数
            base64ToFile(dataurl, filename) {
                //将base64转换为文件
                var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
                    bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
                while(n--){
                    u8arr[n] = bstr.charCodeAt(n);
                }
                return new File([u8arr], filename, {type:mime});
            },
            // 封装一个Blob转base64的函数
            blobToBase64(blobObj) {
                return new Promise((resolve, reject) => {
                    let fr = new FileReader();
                    if(blobObj instanceof Blob) {
                        fr.readAsDataURL(blobObj);
                        fr.onload = function() {
                            resolve(this.result);
                        }
                    }
                });  
            },
            //上传图片
            getimg(e) {
                console.log(e);
                let that = this;
                var files = e.target.files[0];
                // 如果图片大小大于2M则开启压缩
                if(files.size > 1024 * 1024 * 1) {
                    this.blobToBase64(files).then((res) => {
                        this.compressImg(res, { quality: 0.6 }).then((res) => {
                            let file = this.base64ToFile(res, files.name);
                            this.files[0] = file;
                        });
                    });
                }else {
                    this.files[0] = files;
                }

                console.log(this.files)

                if (!e || !window.FileReader) return; // 看支持不支持FileReader

                if(files){
                    let reader = new FileReader();
                    reader.readAsDataURL(files);  // 读取文件
                    reader.onloadend = function() {
                        that.uploadPic.show=false;
                        that.uploadPic.imgUrl = this.result;
                    };
                }
            },
            // 执行 visibilitychange事件
            addVisibles(){
                var hidden, state, visibilityChange; 
                if (typeof document.hidden !== "undefined") {
                    hidden = "hidden";
                    visibilityChange = "visibilitychange";
                    state = "visibilityState";
                } else if (typeof document.mozHidden !== "undefined") {
                    hidden = "mozHidden";
                    visibilityChange = "mozvisibilitychange";
                    state = "mozVisibilityState";
                } else if (typeof document.msHidden !== "undefined") {
                    hidden = "msHidden";
                    visibilityChange = "msvisibilitychange";
                    state = "msVisibilityState";
                } else if (typeof document.webkitHidden !== "undefined") {
                    hidden = "webkitHidden";
                    visibilityChange = "webkitvisibilitychange";
                    state = "webkitVisibilityState";
                }
                document.addEventListener(visibilityChange, this.hiddens, false);
            },
            // 移除 visibilitychange事件
            removeVisible(){
                var hidden, state, visibilityChange; 
                if (typeof document.hidden !== "undefined") {
                    hidden = "hidden";
                    visibilityChange = "visibilitychange";
                    state = "visibilityState";
                } else if (typeof document.mozHidden !== "undefined") {
                    hidden = "mozHidden";
                    visibilityChange = "mozvisibilitychange";
                    state = "mozVisibilityState";
                } else if (typeof document.msHidden !== "undefined") {
                    hidden = "msHidden";
                    visibilityChange = "msvisibilitychange";
                    state = "msVisibilityState";
                } else if (typeof document.webkitHidden !== "undefined") {
                    hidden = "webkitHidden";
                    visibilityChange = "webkitvisibilitychange";
                    state = "webkitVisibilityState";
                }
                document.removeEventListener(visibilityChange, this.hiddens, false);
            },
            // 封装执行函数
            changeInit(){
                if(this.$route.query.ids){
                    this.init();
                } else {
                    this.$toast('请返回快速任务页重新进入该页面')
                }
            },
            // 初始化请求
            init(){
                this.$loading(true);
                let datas = {
                    task_id:this.$route.query.ids
                }
                this.$http.POSTS('fast_task/detail',datas,(res)=>{
                    console.log(res.data)
                    // let urlObj = {};
                    // urlObj.imgUrl = '';
                    // urlObj.show = true;
                    // this.uploadPic.push(urlObj);
                    // console.log(uploadPic);
                    this.detailData = res.data
                    this.countDownFun(res.data.task_endtime);
                    if(this.detailData.api_type == 2) {
                        this.tips = '下载';
                    }
                    if(this.detailData.reservation_pic) {
                        this.url = this.detailData.reservation_pic;
                    }
                    // 把价格传给领奖弹窗
                    this.pops.contsRed = this.detailData.price;
                    // 检测应用是否打开过
                    this.checkopen();

                    this.$loading(false);
                });
            },
            // 封装倒计时
            countDownFun(taskEndTime){
                if(taskEndTime <= 0){
                    this.surplusTimes = '00:00'
                    clearInterval(this.timer)
                } else {
                    this.timeFormat(taskEndTime);
                    this.timer = setInterval(()=>{
                        taskEndTime--;

                        if(taskEndTime <= 0){
                            this.surplusTimes = '00:00'
                            clearInterval(this.timer)
                        } else {
                            this.timeFormat(taskEndTime);
                        }
                        
                    },1000)
                }
            },
            timeFormat(taskEndTime){
                let endTimeMinute = Math.floor(taskEndTime/60%60);
                let endTimeSecond = Math.floor(taskEndTime%60);
                endTimeMinute = endTimeMinute>=10?endTimeMinute:'0'+endTimeMinute;
                endTimeSecond = endTimeSecond>=10?endTimeSecond:'0'+endTimeSecond;
                this.surplusTimes = endTimeMinute+':'+endTimeSecond;
            },
            // 返回
            returnPage:function(){
                // this.$router.go(-1);
                if(this.$route.query.ids){
                    this.choosePop = true;
                    // clearInterval(this.timer)
                } else {
                    this.$router.go(-1);
                    clearInterval(this.timer)
                }
            },

            // 点击跳转appstore
            toAppstore(){
                console.log(this.detailData.url)
                if(this.detailData.iskeywords == 1){
                    // 没有关键词
                    window.location.href = this.detailData.url
                } else if(this.detailData.iskeywords == 2) {
                    // 有关键词
                    window.location.href = 'https://itunes.apple.com/WebObjects/MZStore.woa/wa/search?mt=8&submit=edit&term='+''+'#software'
                    // var clipboard = new Clipboard('.oneBtn')
                    // clipboard.on('success', e => {
                    //     this.$toast('复制关键词成功')
                    //     setTimeout(()=>{
                    //         window.location.href = 'https://itunes.apple.com/WebObjects/MZStore.woa/wa/search?mt=8&submit=edit&term='+''+'#software'
                    //     },1500)
                    //     // 释放内存
                    //     clipboard.destroy()
                    // })
                    // clipboard.on('error', e => {
                    //     // 不支持复制
                    //     this.$toast('该浏览器不支持自动复制')
                    //     // 释放内存
                    //     clipboard.destroy()
                    // })
                }  
            },
            // 打开应用
            openApp() {
                // 可以领奖后不在打开应用 （钱大师这边暂时不要这个判断）
                // if(this.receiveReward === true) {
                //     return;
                // }
                if(this.detailData.task_assistance.is_ios11 === true) {
                    this.checkInstallForiOS11();
                }else {
                    this.checkInstallForiOS10();
                }
            },
            // iOS 10及以下检测是否安装应用并打开
            checkInstallForiOS10() {
                let params = '?bundleid=' + encodeURIComponent(this.detailData.boundid);
                clientApi.isAppExistForiOS10(params).then((response)=> {
                    if (response.status == 1) {
                        //1直接打开应用，2推送本地消息
                        clientApi.ios11openurl(data).then((response)=> {
                            let pushData={title:"温馨提示：您的任务正在进行中，打开时请允许App网络访问哟"};
                            clientApi.localpush(pushData);

                            //开始任务
                            this.clientStartTask();
                        }).catch( (err)=> {
                            Dialog.alert({message: '网络错误'});
                        });
                    }else {
                        Dialog.alert({message: 'APP未安装，快去APP store下载吧'});
                    }
                }).catch( (err)=>{
                    Dialog.alert({message: '网络错误'});
                });
            },
            // iOS 11及以上检测是否安装应用并打开
            checkInstallForiOS11() {
                let data={bundleid: encodeURIComponent(this.detailData.boundid)};
                clientApi.ios11openurl(data).then((response)=> {
                    if(response.data==1){
                        let pushData={title:"温馨提示：您的任务正在进行中，打开时请允许App网络访问哟"};
                        clientApi.localpush(pushData);

                        //开始任务
                        this.clientStartTask();
                    }else {
                        Dialog.alert({message: 'APP未安装，快去APP store下载吧'});
                    }
                }).catch( (err)=> {
                    Dialog.alert({message: '网络错误'});
                });
            },
            // 检测是否安装应用后再开始客户端任务
            clientStartTask() {
                let starttaskData={
                    bundleid: this.detailData.boundid,
                    task_id: this.detailData.id,
                    idfa: this.detailData.task_assistance.idfa,
                    taskname: "是否打开任务『"+ this.detailData.name + "』"
                }
                clientApi.v2cattrystarttask(starttaskData).then((response)=>{
                    if(response.status == "1"){
                        this.checkopen();
                    }else{
                        if(response.data == -51){
                            Dialog.alert({message: '广告标识符修改过，请放弃任务，重新登录'});
                        }else if(response.data == -50){
                            Dialog.alert({message: '数据错误'});
                        }else if(response.data == -100){
                            Dialog.alert({message: '网络超时'});
                        }else{
                            Dialog.alert({message: '数据错误'+ response.data});
                        }
                    }
                }).catch ((err)=>{
                    console.log(err)
                });
            },
            // 检测原来是否打开过应用
            checkopen() {
                let datas = {
                    task_id: this.detailData.id,
                    idfa: this.detailData.task_assistance.idfa,
                    boundid: this.detailData.boundid
                }
                this.$http.POSTS('fast_task/isOpenApp',datas,(res)=>{
                    this.$loading(false);
                    console.log(res.data)
                    if(res.data.is_open == 1) {
                        // 如果本身打开过应用直接开始计时
                        this.activeAppTimeCount();
                    }else {
                        return false;
                    }
                });
            },
            // 领取奖励
            reward:function(){
                this.$loading(true);
                if(this.appleid ==='') {
                    this.$loading(false);
                    this.$toast('请输入Apple ID')
                    return;
                }
                if(this.uploadPic.imgUrl === '') {
                    this.$loading(false);
                    this.$toast('请上传图片')
                    return;
                }
                let datas = {
                    task_id:this.$route.query.ids,
                    appleid:this.appleid,
                    img:this.uploadPic.imgUrl
                }
                this.$http.POSTS('fast_task/submitReservation',datas,(res)=>{
                    this.$loading(false);
                    if(res.flag == "success") {
                        // Dialog.alert({title: "温馨提示", message: "提交成功,我们会尽快审核"});
                        this.rewards=true;
                    }else{
                        Dialog.alert({title: "温馨提示", message: res.msg})
                    }
                    console.log(res)
                    
                });
                return;
            },
            // 到可以领奖的倒计时
            activeAppTimeCount() {
                if(this.activeAppTimer) {
                    return;
                }
                let params = "?bundleid=" + this.detailData.boundid;
                this.activeAppTimer = setInterval(() => {
                    clientApi.checkOpenAppTime(params).then((response) => {
                        if (response.status != 1) {
                            return false;
                        }
                        let time = parseInt(response.data) + 180;
                        let nowDate = new Date();
                        let nowTime = nowDate.getTime() / 1000;
                        let openAppTime = parseInt(time - nowTime);
                        if(openAppTime < 0){
                            clearInterval(this.activeAppTimer);
                            this.receiveReward = true;
                        }
                    }).catch(function (err) {
                        console.log(err);
                    });
                }, 1500)
            },
            fatherMethod:function(){
                this.rewards = false;
                this.$router.replace('/fastTasks');
            },
            closed:function(){
                this.rewards = false;
                this.$router.replace('/fastTasks');
            },

            // 放弃任务
            giveUp:function(){
                let datas = {
                    task_id:this.$route.query.ids
                }
                this.$http.POSTS('fast_task/untask',datas,(res)=>{
                    this.choosePop = false
                    this.$router.go(-1);
                });
                
            },
            // 不放弃任务
            notGiveUp:function(){
                this.choosePop = false
            }
        },

        beforeRouteEnter(to, from, next) {
            if(from.name=='fastTasks'){
                to.meta.keepAlive = false;
            } else {
                to.meta.keepAlive = true;
            }
            next();
        },
    }
</script>

<style lang="less" scoped>
    #missionDetails{
        // 导航栏
        #headers{
            width: 375px;
            height: 45px;
            background: linear-gradient(to right,#EB3F47,#E50113);
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            img{
                width: 11px;
                height: 18px;
                position: absolute;
                left: 15px;
                padding: 0 3px;
            }
            .headerText{
                font-size: 15px;
                color: #FFFFFF;
            }
        }
        // 头部
        .headerTop{
            width:375px;
            height:35px;
            background:linear-gradient(313deg,rgba(229,1,19,1) 0%,rgba(235,63,71,1) 100%);
            .timePanel{
                width:345px;
                height:60px;
                background:rgba(255,255,255,1);
                box-shadow:0px 5px 10px 0px rgba(0,0,0,0.05);
                border-radius:5px;
                border:1px solid rgba(222,222,222,1);
                position: relative;
                top: 8px;
                margin: 0 15px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                .lefts{
                    margin-left: 30px;
                    .tit{
                        font-size:15px;
                        color:rgba(51,51,51,1);
                        line-height:15px;
                    }
                    .num{
                        margin-left: 10px;
                        font-size:20px;
                        color:rgba(51,51,51,1);
                        line-height:20px;
                        font-weight: bold;
                        font-family: Arial, Helvetica, sans-serif;
                    }
                }
                .rights{
                    margin-right: 22px;
                    font-size:35px;
                    font-family: "Qds";
                    color:rgba(230,9,26,1);
                    line-height:42px;
                    font-weight: bold;
                    position: relative;
                    top: 4px;
                    span{
                        font-size: 14px;
                    }
                }
            }
        }
        // 第一步
        .one{
            margin: 48px 15px 0;
            width:345px;
            background:rgba(255,255,255,1);
            box-shadow:0px 5px 10px 0px rgba(0,0,0,0.05);
            border-radius:5px;
            border:1px solid rgba(222,222,222,1);
            display: flex;
            flex-direction: column;
            align-items: center;
            .sign{
                width:143px;
                height:32px;
                background:rgba(249,249,249,1);
                border-radius:0px 0px 8px 8px;
                border:1px solid rgba(222,222,222,1);
                font-size:13px;
                color:rgba(102,102,102,1);
                text-align: center;
                line-height:32px;
                border-top: none;
                font-weight: bold;
            }
            .icons{
                width: 60px;
                height: 60px;
                margin: 20px 0;
                border-radius:12px;
            }
            .keyWord{
                font-size:20px;
                color:rgba(21,21,21,1);
                line-height:20px;
                font-weight: 600;
                margin-bottom: 10px;
            }
            .ranking{
                font-size:13px;
                font-weight:400;
                color:rgba(51,51,51,1);
                line-height:17px;
                span{
                    font-size: 20px;
                    color: #E50113;
                }
            }
            .oneBtn{
                width:250px;
                height:45px;
                background:linear-gradient(313deg,rgba(229,1,19,1) 0%,rgba(235,63,71,1) 100%);
                box-shadow:0px 5px 10px 0px rgba(229,1,19,0.15);
                border-radius:25px;
                font-size:15px;
                font-weight:500;
                color:rgba(255,255,255,1);
                line-height:45px;
                text-align: center;
                margin: 20px 0;
            }
        }
        // 第二步
        .two{
            width:345px;
            background:rgba(255,255,255,1);
            box-shadow:0px 5px 10px 0px rgba(0,0,0,0.05);
            border-radius:5px;
            border:1px solid rgba(222,222,222,1);
            margin: 15px;
            display: flex;
            flex-direction: column;
            align-items: center;
            .sign{
                width:280px;
                height:32px;
                background:rgba(249,249,249,1);
                border-radius:0px 0px 8px 8px;
                border:1px solid rgba(222,222,222,1);
                font-size:13px;
                font-family:PingFangSC-Medium,PingFang SC;
                font-weight:500;
                color:rgba(102,102,102,1);
                text-align: center;
                line-height:32px;
                border-top: none;
                font-weight: bold;
            }
            .uploadPictures{
                margin: 0 20px;
                display: flex;
                flex-direction: column;
                align-items: center;
                .title{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-bottom: 6px;
                    .redLine{
                        display: inline-block;
                        width:10px;
                        height:3px;
                        background:rgba(229,1,19,1);
                        border-radius:2px;
                        margin: 0 5px;
                    }
                    .txt{
                        font-size:15px;
                        font-weight:600;
                        color:rgba(21,21,21,1);
                        line-height:15px;
                    }
                }
                .pictureFathers{
                    width: 100%;
                    .picture{
                        width: 100%;
                        display: flex;
                        justify-content: space-around;
                        padding-top: 10px;
                        .example{
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            img{
                                width: 90px;
                                height: 160px;
                                border-radius:4px;
                            }
                            .example_one{
                                position:absolute;
                                z-index: 1;
                            }
                            .example_two{
                                align-items: flex-start;
                                width: 35px;
                                height: 22px;
                                border-radius:4px;
                                position:absolute;
                                z-index: 2;
                            }
                            span{
                                font-size:15px;
                                font-weight:600;
                                color:rgba(21,21,21,1);
                                line-height:15px;
                                margin-top: 11px;
                            }
                        }
                        .choiceImg{
                            width: 90px;
                            height: 160px;
                            position: relative;
                            img{
                                width: 100%;
                                height: 100%;
                                position: absolute;
                                display: block;
                                top:0;
                                border:2px solid rgba(229,1,19,1);
                                border-radius:4px;
                            }
                            input {
                                display: block;
                                width: 100%;
                                height: 100%;
                                opacity: 0;
                                z-index: 10000;
                            }
                        }
                            
                    }
                }
                .btn{
                    width:250px;
                    height:45px;
                    background:linear-gradient(313deg,rgba(229,1,19,1) 0%,rgba(235,63,71,1) 100%);
                    box-shadow:0px 5px 10px 0px rgba(229,1,19,0.15);
                    border-radius:25px;
                    font-size:15px;
                    font-weight:500;
                    color:rgba(255,255,255,1);
                    line-height:45px;
                    text-align: center;
                    margin: 4px 0 30px;
                }
                .explain{
                    font-size:13px;
                    font-weight:400;
                    color:rgba(153,153,153,1);
                    line-height:20px;
                    padding-bottom: 15px;
                }
            }
        }
        .editText{
            display: flex;
            align-items: center;
            flex-direction: row;
            margin: 31px 20px 25px;
            box-shadow:0px 0px 10px 0px rgba(0,0,0,0.05);
            .regNum{
                width: 70%;
                height: 50px;
                border: none;
                font-size: 15px;
                text-align: center;
                padding: 0 20px;
                box-shadow:0px 0px 0px rgba(153,153,153,1);
                background-color:rgba(242,242,242,1);
                margin-bottom: 1px;
                &:first-of-type{
                    border-radius: 5px 5px 0 0;
                }
                &:last-of-type{
                    border-radius: 0 0 5px 5px;
                }
                &:not(:last-of-type){
                    border-bottom: none;
                }
                &:focus{
                    outline:none;
                }
            }
            .appid{
                width:30%;
                height:15px;
                font-size:15px;
                font-weight:500;
                color:rgba(51,51,51,1);
                line-height:15px;
            }
            #phoneNum{
                width: 293px;
                height: 48px;
                border: none;
                font-size: 15px;
                border-radius: 0 0 5px 5px;
                text-align: center;
                padding: 0 20px;
                box-shadow:0px 5px 10px 0px rgba(0,0,0,0.05);
                border:1px solid rgba(222,222,222,1);
                border-top: none;
                margin-bottom: 25px;
                &:focus{
                    outline:none;
                }
            }
        }
    }
</style>